/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ResourceTypes {
    APPROVER_SETTINGS = 'APPROVER_SETTINGS',
    BANK_STATEMENTS = 'BANK_STATEMENTS',
    BUDGETS = 'BUDGETS',
    COMPANIES = 'COMPANIES',
    COUNTERPARTIES = 'COUNTERPARTIES',
    DASHBOARD = 'DASHBOARD',
    EXPENSE_TYPES = 'EXPENSE_TYPES',
    IBANS = 'IBANS',
    INVOICE_ACCOUNTING = 'INVOICE_ACCOUNTING',
    INVOICE_APPROVAL = 'INVOICE_APPROVAL',
    INVOICE_PAYMENTS = 'INVOICE_PAYMENTS',
    INVOICE_SETTLEMENTS = 'INVOICE_SETTLEMENTS',
    INVOICES = 'INVOICES',
    PAYROLL = 'PAYROLL',
    USERS = 'USERS',
    APPROVAL_RULES = 'APPROVAL_RULES',
    PROMPT_BASED_REPORTS = 'PROMPT_BASED_REPORTS',
}
